<template>
  <div class="w-full h-full">
    <transition name="fade">
      <div class="h-full" v-show="item">
        <div
          @click.stop="
            orderingEnabled &&
            !item.is_sold_out&&
            !selectedMenuCategory.is_ordering_disabled &&
            isOrderingDisabled(groupItem)
              ? (item.is_minimum_age_product ? handleAgeConfirmation(item) : addToCart(item))
              : ''
          "
          :id="`_cart-item-${item.Id}`"
          class="flex flex-col h-full onclickFocus"
        >
          <!-- NEW CART ITEM -->
          <div class="mx-4 h-full" v-if="desktopMode">
            <div
              :class="[
                'grid-cols-12 gap-1 w-full cursor-pointer h-full rounded-xl overflow-hidden',
                desktopMode && 'border-2',
                !item.pictureUrl ? 'flex justify-between' : 'grid',
              ]"
              :style="
                  mediumWidth &&
                    userAgent.device.type !== 'desktop' ?
                    itemBackground:''+
                  `border-color: ${customThemeVariables['desktop-border-color']}`
              "
            >
              <div
              :class="['col-span-4',

              menu.product_images_enabled && selectedMenuCategory.enable_product_images ? 'block' : 'hidden',
              ]">
                <Picture
                  :src="item.pictureUrl !== '' ? item.pictureUrl : placeholderImage"
                  alt
                  :class="['object-cover h-full md:w-full']"
                  keepRatio
                />
              </div>
              <div
                :class="[
                  'p-4 pr-4 pl-4 flex flex-col justify-center w-full',
                  menu.product_images_enabled && selectedMenuCategory.enable_product_images ? 'col-span-8' : 'col-span-12',
                  'ml-0',
                ]"
              >
                <h3
                  :class="[
                    'font-semibold text-lg xs:text-sm xs:w-9/12 xs:break-words',
                  ]"
                  v-trans:name="item"
                  :style="makeStyles(titleMain )"
                />
                <div
                  :class="['text-xs flex text-product-gray mt-1 pr-1']"
                  v-trans:description="item"
                ></div>
                <div :class="['flex flex-wrap mt-1']">
                  <!-- source icons: https://www.flaticon.com/packs/allergenic-food-color?word=allergy -->
                  <!-- Allergens components gives back a list of allergens icons -->
                  <!-- An item, usually from the api call, should be provided as props -->
                  <div class="flex md:justify-center">
                  <allergens :item="item" />
                  </div>
                </div>
                <div class="flex items-center justify-between">
                  <span
                    class="font-semibold text-sm mt-1 opacity-60"
                    :style="text"
                    >
                    {{ displayPrice }}
                    </span
                  >
                  <div v-if="item.is_sold_out" class="flex justify-center items-center pt-2">
                    <p class="text-center text-red-600 border border-2 px-2  border-red-500 rounded-xl">
                      {{lang["sold_out"][language]}}
                    </p>
                  </div>
                  <div
                    v-if="menu.is_ordering_enabled && !item.is_sold_out && orderingEnabled &&
                        !selectedMenuCategory.is_ordering_disabled &&
                        isOrderingDisabled(groupItem)
    "
                    :class="[
                      'flex items-center py-2',
                      !item.pictureUrl ? 'pr-4' : '',
                    ]"
                  >
                    <div
                      @click.stop="removeFromCart(item)"
                      v-if="countQuantity(item)"
                      :class="[
                        'w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center',
                      ]"
                      :style="`background-color: ${customThemeVariables['addition-add--background']}`"
                    >
                      <Icon
                        name="minus"
                        size="20"
                        :color="customThemeVariables['kiosk-detail--text']"
                      />
                    </div>
                    <div
                      v-if="countQuantity(item)"
                      class="px-2"
                    >
                      {{countQuantity(item)}}
                    </div>
                    <div
                      class="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center cursor-pointer"
                      :style="`background-color: ${customThemeVariables['addition-add--background']}`"
                    >
                      <Icon
                        name="plus"
                        size="20"
                        :color="customThemeVariables['kiosk-detail--text']"
                      />
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>

          <div v-else class="flex flex-row h-full">
            <div
              :class="[
                'select-none',
                'rounded-md flex flex-1 items-center h-full',
              ]"
            >
              <!-- NEW CART ITEM OLD POSITION -->

              <div
                :class="[
                  'cursor-pointer w-full h-full flex border-b-2 md:rounded-b-xl mx-4 pb-6 md:pb-0 pl-4 md:pl-0 transition duration-500 items-center justify-between rounded-t-lg',
                  userAgent.device.type === 'desktop'
                    ? 'border-2 border-gray-300 flex-row'
                    : 'md:flex-col',
                ]"
                :style="[
                    mediumWidth &&
                      userAgent.device.type !== 'desktop' &&
                      itemBackground
                      ]
                "
              >
                <!-- left side product -->
                <div
                  :class="[
                    'flex',
                    'w-2/3 md:w-full',
                    desktopMode ? 'flex-row' : 'md:flex-col',
                  ]"
                >
                  <div
                    :class="[
                      'flex-none flex items-center overflow-hidden rounded-t-lg justify-center',
                      menu.product_images_enabled && selectedMenuCategory.enable_product_images
                        ? 'block'
                        : 'hidden',
                      'w-20 h-20 md:h-56 md:w-full',
                    ]"
                  >
                    <Picture
                      :src="item.pictureUrl !== '' ? item.pictureUrl : placeholderImage"
                      alt
                      :class="['object-cover  h-full md:w-full']"
                    />
                  </div>
                  <div
                    :class="[
                      'flex-grow ml-4 md:ml-0',
                      orderingEnabled ? '' : 'items-center flex xs:mb-6',
                    ]"
                  >
                    <div class="flex-1 md:px-2">
                      <div :class="['font-medium justify-between']"
                      >
                        <!-- item name (title)-->
                        <span
                          :class="[
                            /*theme.body.text*/ 'font-semibold text-lg md:mt-1 md:text-center xs:text-sm xs:w-9/12 xs:break-words',
                            ,
                            'md:flex md:justify-center',
                          ]"
                          v-trans:name="item"
                          :style="titleMain"
                        ></span>
                      </div>
                      <!-- item price -->
                      <div
                        :class="[
                          'text-xs flex text-product-gray md:text-center mt-1',
                          'md:flex md:justify-center',
                        ]"
                        v-trans:description="item"
                      ></div>

                      <!-- class="text-new-primary font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden"
                            :style="listsText" -->
                      <span
                        class="font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden xs:text-xs"
                        :style="text"
                        v-if="orderingEnabled"
                        >
                        {{ displayPrice }}
                      </span>

                      <div
                        :class="['flex flex-wrap mt-1', 'md:justify-center']"
                      >
                        <!--source icons: https://www.flaticon.com/packs/allergenic-food-color?word=allergy-->
                        <div class="flex md:justify-center">
                        <allergens :item="item" />
                        </div>
                        <div v-if="item.is_sold_out" class="flex md:hidden justify-center items-center pt-3">
                          <p class="text-center text-red-600 border border-2 px-2  border-red-500 rounded-xl">
                            {{lang["sold_out"][language]}}
                          </p>
                        </div>
                      </div>
                      <span
                        :class="[
                          'text-new-primary font-semibold text-sm md:flex md:justify-center hidden md:block',
                          !orderingEnabled ? 'mb-2' : '',
                        ]"
                        :style="listsText"
                        >
                        {{ displayPrice }}
                      </span>
                    </div>
                  </div>
                  
                </div>
                <!-- right side product -->
                <div
                  v-if="
                    orderingEnabled &&
                    !item.is_sold_out &&
                    selectedMenuCategory.is_ordering_disabled == false
                  "
                  :class="[
                    'flex items-center mt-2 md:flex-row xs:justify-end',
                    !desktopMode && 'w-1/3 md:w-full',
                  ]"
                >
                  <div
                    v-if="countQuantity(item)"
                    :class="[
                      'flex items-center rounded-full w-full xs:justify-end',
                      /* theme.addToCart.backgroundColorPlus, */
                    ]"
                  >
                    <!-- buttton when 1 item is in basket -->
                    <div
                      class="flex flex-row md:rounded-t-none rounded-xl border-new-primary relative bg-primary-100 justify-center items-center border-2 w-full mr-4 md:mr-0 px-1 xs:mr-0 xs:w-4/5 xs:justify-end h-8"
                      v-if="
                        orderingEnabled &&
                        !item.is_sold_out &&
                        selectedMenuCategory.is_ordering_disabled == false
                      "
                      :style="
                        btnOutlineActiveBorder + btnOutlineActiveBackground
                      "
                    >
                      <!-- min button -->
                      <div @click.stop="removeFromCart(item)" class="md:w-1/3">
                        <button
                          :class="[
                            'sm:w-10 productClick fill-current focus:outline-none inline-block font-bold  rounded-full flex items-center',
                            {'opacity-80 cursor-not-allowed':disableAddButton}
                          ]"
                          :disabled="disableAddButton"
                        >
                        <IconMinus
                            :stroke="buttonImgColors"
                            :style="btnOutlineIcon"
                        />
                        </button>
                      </div>
                      <div
                        v-if="itemBeingAdded == item.Id"
                        :class="['spinner-white w-2 flex-1']"
                        style="position: relative !important"
                      >
                        <input
                          type="number"
                          readonly
                          class="focus:outline-none text-center text-new-primary font-bold text-md md:text-basecursor-default flex items-center outline-none w-full justify-center bg-primary-100 xs:text-xs h-6"
                          name="custom-input-number"
                          :value="
                            $_.countBy(cartItems, (el) => el.Id == item.Id)
                              .true || 0
                          "
                          :style="
                            btnOutlineActiveBackground + btnOutlineActiveText
                          "
                        />
                      </div>
                      <input
                        v-else
                        type="number"
                        readonly
                        class="static focus:outline-none text-center text-new-primary font-bold text-sm sm:text-md md:text-basecursor-default flex items-center outline-none w-full  md:w-1/3 justify-center bg-primary-100 xs:text-xs h-6"
                        name="custom-input-number"
                        :value="
                          $_.countBy(cartItems, (el) => el.Id == item.Id)
                            .true || 0
                        "
                        :style="
                          btnOutlineActiveBackground + btnOutlineActiveText
                        "
                      />
                      <!-- plus button -->
                      <div class="md:w-1/3 md:flex md:justify-end">
                        <button
                          @click.stop="addToCart(item)"
                          :disabled="disableAddButton"
                          :class="[
                            'sm:w-10 productClick font-bold md:w-10 rounded-full cursor-pointer focus:outline-none flex items-center justify-end',
                          ]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="w-5 md:w-10 h-10 xs:w-3 xs:h-3"
                          >
                            <path
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              fill="none"
                              :stroke="buttonImgColors"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-else
                    :class="[
                      'md:items-center w-full justify-center mr-4 md:mr-0 text-right xs:mr-0 xs:w-4/5 xs:justify-end',
                    ]"
                    @click.stop="(item.is_minimum_age_product ? handleAgeConfirmation(item) : addToCart(item))"
                  >
                    <!-- button without item selected in cart -->
                    <div
                      v-if="
                        orderingEnabled &&
                        selectedMenuCategory.is_ordering_disabled == false &&
                        !item.is_sold_out &&
                        isOrderingDisabled(groupItem)
                      "
                      class="xs:p-0 p-1 md:rounded-t-none rounded-xl items-center justify-end transition duration-500 border-2 w-auto inline-block md:w-full md:text-center flex justify-center bg-white h-8"
                      :style="btnOutlineBorder + btnOutlineBackground"
                    >
                      <p
                        class="text-sm sm:px-2 text-primary-400 font-semibold xs:text-xxs"
                        :style="btnOutlineText"
                      >
                        + {{ lang["add_to_cart"][language] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="!orderingEnabled">
                  <span
                    class="text-new-primary font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden xs:text-sm"
                    :style="listsText"
                    >
                    {{ displayPrice }}
                  </span>
                </div>
                <div v-if="item.is_sold_out" class="hidden md:flex justify-center items-center pb-2">
                  <p class="text-center text-red-600 border border-2 px-2  border-red-500 rounded-xl">
                    {{lang["sold_out"][language]}}
                  </p>
                </div>

              </div>

              <div
                :class="['text-gray-600 text-xs']"
                v-if="$route.name == 'Home'"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from "./Icon.vue";
import Allergens from "./Allergens.vue";
import { mapGetters } from "vuex";
// import { styles } from "../utils";
import lang from "../lang";
import IconMinus from "./icons/iconMinus.vue";

export default {
  components: {
    Icon,
    Allergens,
    IconMinus
},
  props: {
    item: {
      type: Object,
      require: true,
    },
    groupItem: {
      type: [Object,Array],
      require: true,
    },
    showModifierModal: {
      type: Boolean,
      require: true,
    },
    removeFromCart:{
      type:Function,
      require:true,
    },
  },
  data() {
    return {
      lang: lang,
      mediumWidth: false,
      itemBeingAdded: undefined,
      disableAddButton: false,
      // showModifierModal: true,
      deleteCorrectItem: [],
    };
  },
  computed: {
    ...mapGetters([
      "menu",
      "userAgent",
      "desktopMode",
      "orderingEnabled",
      "currency",
      "language",
      "menuCategories",
      "minSelectedAddition",
      "selectedMenuCategory",
      "placeholderImage"
    ]),
    ...mapGetters("Theme", [
      "listsText",
      "text",
      "titleMain",
      "titleFont",
      "titleTextTransform",
      "btnOutlineBorder",
      "buttonImgColors",
      "itemBackground",
      "btnOutlineText",
      "btnOutlineIcon",
      "btnOutlineBackground",
      "customThemeVariables",
      "btnOutlineActiveBackground",
      "btnOutlineActiveText",
      "btnOutlineActiveBorder",
    ]),
    ...mapGetters("Cart", [
      "cartItems",
      "items",
      "subCategoryCurrentItem"
    ]),
      modifiers: {
      get() {
        return this.subCategoryCurrentItemModifier;
      },
      set(value) {
        return this.$store.commit(
          "Cart/updateSubCategoryCurrentItemModifier",
          value
        );
      },
    },
      currentItem: {
        get() {
          return this.subCategoryCurrentItem;
        },
        set(value) {
          return this.$store.commit("Cart/updateSubCategoryCurrentItem", value);
        },
    },
    displayPrice() {
      if (this.item.price === 0 && this.item.isComboDeal) {
        return this.lang["make_choice"][this.language]
      } else if(this.item.price > 0) {
        return this.pricify(this.item.price)
      } else {
        return '';
      }
    },


  },
  methods: {
    countQuantity(item) {
      return this.$_.countBy(this.cartItems, (el) => el.Id == item.Id).true || 0;
    },
    // styles,
    // Checking if the 'add to cart' button should be visible and clickable, is_ordering_disabled = false/true
    // This check is different than 'selectedMenuCategory' because with infinity scroll the last category items can be displayed without being 'selected'
    isOrderingDisabled(groupItem) {
      // Loop through base menu info to find additional information about menu, in this case look for 'is_ordering_disabled'
      /** groupItem value is only used in infinite scroll menu , if menu is non infinity scroll type return true so that
       * this condition make no effect with and(&) operator */
      return !this.menuCategories.find((x) => x.Id == groupItem.Id)
        ?.is_ordering_disabled;
    },
    addToCart(item) {
        if (this.isUpselling) {
          this.$modal.hide("upselling-items");
        }

      this.$store.commit("updateItemPrice", item.price);
      this.$store.commit("Cart/updateOrderItemCount", 1);
      // if this.disableAddButton is false we can order, this ensures that you can't order super fast and create bugs with it
      if (this.disableAddButton != true) {
        this.disableAddButton = true;
        if (
          this.orderingEnabled &&
          this.selectedMenuCategory.is_ordering_disabled == false
        ) {
          this.currentItem = item;
          this.$store.commit("updateCategoryId", item.MenuCategoryId);
          this.itemBeingAdded = this.currentItem.Id;
          this.$store
            .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
            .then((response) => {
              this.itemBeingAdded = "";
              if (response.data.Modifiers.length) {
                this.modifiers = response.data.Modifiers;

                // Create a Set to store unique addition_group values
                const uniqueGroups = new Set();
                // Create a set to store all additionStep values
                const uniqueAdditionSteps = new Set();
                // Add each addition_group value to the Set and unique additionStep value to the set
                response.data.Modifiers.forEach(item => {
                  uniqueGroups.add(item.additionStep);
                  uniqueAdditionSteps.add(item.additionStep);
                });

                // The size of the Set is the number of distinct addition_groups
                const distinctGroupCount = uniqueGroups.size;
                // Convert the Set of unique addition steps back to an array
                const additionStepsArray = Array.from(uniqueAdditionSteps);

                if (distinctGroupCount > 0) {
                  this.$store.commit("updateModifiersSelectionGroups", distinctGroupCount);
                }
                // Save the array of all additionStep values
                this.$store.commit("saveAdditionStepsArray", additionStepsArray);

                if (this.showModifierModal) {
                  this.$modal.show("item-modifiers");
                }
                this.$store.commit("updateMinSelectedAddition", 0);
              } else {

                this.$store.dispatch("Cart/UPDATE_ORDER", {
                  operation: "add",
                  item: this.currentItem,
                });
              }
              setTimeout(() => {
                this.disableAddButton = false;
              }, 150);

              if (!response.data.Modifiers.length) {
                let cartbutton =
                  document.querySelectorAll(".fixedDesktopCart")[0];
                cartbutton.classList.add("animatedViewOrderButton");

                setTimeout(function () {
                  document
                    .querySelectorAll(".fixedDesktopCart")[0]
                    .classList.remove("animatedViewOrderButton");
                }, 1100);
              }
            })
            .catch(() => {
              this.itemBeingAdded = "";
            });
        }
      }
    },
    handleAgeConfirmation(item) {
      this.$modal.show('confirmAge')
      this.$store.commit("updateMinimumAgeProduct", item)
    },
  },
  created() {
    if (window.innerWidth > 769) {
      this.mediumWidth = true;
    }
  },
};
</script>

<style scoped>
.onclickFocus {
  outline: none;
  box-shadow: none;
  border: 0;
  text-decoration: none;
}
.onclickFocusKiosk {
  outline: none;
  box-shadow: none;
  border: 0;
  text-decoration: none;
}

.productClick {
  max-width: 30px;
}
.clickAnimation:active {
  transform: scale(1.1);
}
.clickAnimation {
  transition: 1s;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}


</style>
